// Przełącznik orientacji filtrów (pionowe/poziome kafelki/poziome jeden wiersz)

import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import classnames from 'classnames';
import ViewSidebarRoundedIcon from '@mui/icons-material/ViewSidebarRounded';
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';

import styles from 'theme/components/controls/FiltersSwitcher/FiltersSwitcher.module.scss';

export type FiltersOrientation = 'vertical' | 'horizontal-wrap' | 'horizontal-row';

export interface IProps {
  orientation: FiltersOrientation;
  onChange: (orientation: FiltersOrientation) => void;
}

const FiltersSwitcher: FC<IProps> = ({ orientation, onChange }) => {
  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Components-Controls-FiltersSwitcher'
      )}>
      <span className={styles.name}>
        <Trans>Filtry</Trans>:{' '}
      </span>
      <ViewSidebarRoundedIcon
        className={classnames(styles.icon, { [styles.active]: orientation === 'vertical' })}
        onClick={() => orientation !== 'vertical' && onChange('vertical')}
      />
      <TableChartRoundedIcon
        className={classnames(styles.icon, { [styles.active]: orientation === 'horizontal-row' })}
        onClick={() => orientation !== 'horizontal-row' && onChange('horizontal-row')}
      />
      <GridViewRoundedIcon
        className={classnames(styles.icon, { [styles.active]: orientation === 'horizontal-wrap' })}
        onClick={() => orientation !== 'horizontal-wrap' && onChange('horizontal-wrap')}
      />
    </div>
  );
};

export default FiltersSwitcher;
